import clsx from "clsx";
import { Skeleton } from "../Skeleton";
import styles from "./SkeletonCompanyRow.module.scss";

export function SkeletonCompanyRow() {
  return (
    <div className={styles.container}>
      <div>
        <Skeleton width={20} height={20} borderRadius={6} className={styles.section} />
      </div>
      <div className={clsx(styles.companyDetails, styles.section)}>
        <Skeleton width={40} height={40} borderRadius={6} />
        <div className={styles.companyDetailsContainer}>
          <Skeleton width={108} height={16} borderRadius={6} />
          <Skeleton width={296} height={8} borderRadius={6} />
          <Skeleton width={296} height={8} borderRadius={6} />
          <div className={styles.companyDetailsBottomContainer}>
            <Skeleton width={56} height={24} borderRadius={13} />
            <Skeleton width={56} height={24} borderRadius={13} />
            <Skeleton width={56} height={24} borderRadius={13} />
          </div>
        </div>
      </div>
      <div>
        <Skeleton width={80} height={14} borderRadius={6} className={styles.section} />
      </div>
      <div>
        <Skeleton width={80} height={14} borderRadius={6} className={styles.section} />
      </div>
      <div>
        <Skeleton width={80} height={14} borderRadius={6} className={styles.section} />
      </div>
      <div className={clsx(styles.foundersContainer)}>
        <div className={styles.founder}>
          <Skeleton width={24} height={24} borderRadius={100} />
          <Skeleton width={80} height={14} borderRadius={6} />
        </div>
        <div className={styles.founder}>
          <Skeleton width={24} height={24} borderRadius={100} />
          <Skeleton width={80} height={14} borderRadius={6} />
        </div>
      </div>
      <div>
        <Skeleton width={80} height={14} borderRadius={6} className={styles.section} />
      </div>
      <div>
        <Skeleton width={80} height={14} borderRadius={6} className={styles.section} />
      </div>
      <div>
        <Skeleton width={36} height={36} borderRadius={13} className={styles.section} />
      </div>
    </div>
  );
}
